"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.CustomSwitch = void 0;
var _styles = require("@material-ui/styles");
var _core = require("@material-ui/core");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      display: 'flex',
      alignItems: 'center'
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: theme.palette.NEUTRAL800,
      cursor: 'pointer'
    },
    labelDisabled: {
      color: theme.palette.NEUTRAL100,
      cursor: 'auto'
    }
  };
});
exports.useStyles = useStyles;
var CustomSwitch = (0, _core.withStyles)(function (theme) {
  var thumbAdditionals = {};
  return {
    root: {
      width: 40,
      height: 20,
      padding: 0,
      display: 'flex',
      marginRight: theme.spacing(1),
      overflow: 'visible',
      '&.Mui-focusVisible': {
        border: "2px solid ".concat(theme.palette.RED500),
        '& $switchBase::before': {
          opacity: 1
        }
      }
    },
    switchBase: {
      position: 'static',
      padding: 0,
      color: theme.palette.grey[500],
      transition: 'left 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:hover': {
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.NEUTRAL100,
          borderColor: theme.palette.NEUTRAL100,
          transition: 'all 0.2s ease-in'
        },
        '& $thumb': {
          borderColor: theme.palette.NEUTRAL100,
          transition: 'all 0.2s ease-in'
        }
      },
      '& input': {
        left: 0,
        width: '100%'
      },
      '&$checked': {
        transform: 'translateX(20px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.BLUE400,
          borderColor: theme.palette.BLUE400
        },
        '& $thumb': {
          borderColor: theme.palette.BLUE400
        },
        '& input': {
          width: 40,
          left: '-16px'
        }
      },
      '&$checked:hover': {
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.BLUE500,
          borderColor: theme.palette.BLUE500
        },
        '& $thumb': {
          borderColor: theme.palette.BLUE500
        }
      }
    },
    thumb: _objectSpread({
      boxShadow: theme.shadows[1],
      padding: 0,
      border: "1px solid ".concat(theme.palette.NEUTRAL100),
      background: "#FFF no-repeat center",
      borderRadius: 18,
      left: 0,
      position: 'absolute',
      display: 'inline-block',
      // transition: `border-color 250ms cubic-bezier(0.34, 1.61, 0.7, 1), background-color 250ms cubic-bezier(0.34, 1.61, 0.7, 1), left 250ms cubic-bezier(0.34, 1.61, 0.7, 1), transform 250ms cubic-bezier(0.34, 1.61, 0.7, 1), -webkit-transform 250ms cubic-bezier(0.34, 1.61, 0.7, 1)`,
      transition: 'all 0.2s ease-in',
      width: 18,
      height: 18
    }, thumbAdditionals),
    track: {
      borderRadius: 20,
      opacity: 1,
      backgroundColor: theme.palette.NEUTRAL050,
      transition: 'all 0.2s ease-in',
      '&::before': {
        content: "''",
        width: 46,
        height: 26,
        display: 'block',
        zIndex: -1,
        position: 'absolute',
        border: "2px solid ".concat(theme.palette.BLUE400),
        borderRadius: 20,
        top: -5,
        left: -5,
        opacity: 0,
        transition: 'all 0.2s ease-in',
        '.Mui-focusVisible + &': {
          opacity: 1,
          transition: 'all 0.2s ease-in'
        }
      }
    },
    checked: {},
    disabled: {
      '&$switchBase': {
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.NEUTRAL030,
          borderColor: theme.palette.NEUTRAL030
        },
        '& $thumb': {
          border: "1px solid ".concat(theme.palette.NEUTRAL050),
          boxShadow: 'none'
        }
      },
      '&$switchBase$checked': {
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.BLUE075,
          borderColor: theme.palette.BLUE075
        },
        '& $thumb': {
          borderColor: theme.palette.BLUE075
        }
      }
    }
  };
})(_core.Switch);
exports.CustomSwitch = CustomSwitch;